import React from 'react';
import { Clickable, P, Tabs } from '@fashionnovateam/nova-ui-toolkit';
import { ExclusivityToggleProps } from '../types';

export function ExclusivityToggle({
  worksheetId,
  value,
  onUpdate,
  disabled = false,
}: ExclusivityToggleProps) {
  const isExclusive =
    value === 'FN Exclusive' || value === 'Exclusive Going Forward';

  const handleSelectExclusive = () => {
    if (!disabled) {
      // Preserve 'Exclusive Going Forward' state - only change if currently 'Not Exclusive'
      if (value === 'Exclusive Going Forward' || value === 'FN Exclusive') {
        // Already exclusive, no change needed
        return;
      }
      onUpdate({
        worksheet_id: worksheetId,
        exclusivity: 'FN Exclusive',
      });
    }
  };

  const handleSelectNotExclusive = () => {
    if (!disabled) {
      onUpdate({
        worksheet_id: worksheetId,
        exclusivity: 'Not Exclusive',
      });
    }
  };

  if (disabled) {
    return (
      <div className="flex items-center justify-center w-full h-10">
        <P size="sm" color="disabled">
          {isExclusive ? 'Yes' : 'No'}
        </P>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full h-10">
      <Tabs.Group type="segment">
        <Clickable onClick={handleSelectExclusive} disabled={disabled}>
          <Tabs.Item type="segment" isActive={isExclusive}>
            Yes
          </Tabs.Item>
        </Clickable>
        <Clickable onClick={handleSelectNotExclusive} disabled={disabled}>
          <Tabs.Item type="segment" isActive={!isExclusive}>
            No
          </Tabs.Item>
        </Clickable>
      </Tabs.Group>
    </div>
  );
}
